import {getRepresentative} from "@project/sdk/sales";
import {GetRepresentativeResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {representativeKeys} from "../../../representative-keys";

export function getRepresentativeQueryOptions(id: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...representativeKeys.detail(id), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetRepresentativeResponse.parse(await getRepresentative(id, {includeDeleted}, {signal})),
  });
}
